import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import actions from "store/actions";
import { State } from "store/reducers";
import Report from "Components/Report";
import ls from "Localization";
import ISplit from "Types/Split";
import { toStringCurrency } from "helpers/string";
import { InvoiceState } from "store/reducers/invoice";
import ReactTable from "react-table";
import _ from "lodash";
import IInvoice from "Types/Invoice";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

let getInvoicesDebounced: (() => any) & _.Cancelable;

function Invoicing({ id }) {
	const dispatch = useDispatch<any>();
	const table = useRef<ReactTable<any>>(null);

	const state = useSelector<State, InvoiceState>(s => s.invoice);

	const handleFetchData = (tableState: any) => {
		if (!tableState) return;
		const { page, pageSize, toExport, callback } = tableState;
		let { sorted, filtered } = tableState;

		if (getInvoicesDebounced) {
			getInvoicesDebounced.cancel();
		}

		if (!sorted) sorted = [];

		filtered = [...(filtered || [])];

		filtered.push({
			id: "meiId",
			value: id
		});

		getInvoicesDebounced = _.debounce(
			() =>
				dispatch(
					actions.invoice.getInvoicing(
						page * pageSize,
						pageSize,
						filtered.reduce(
							(p: any, c: any) => p + `&filters[${c.id}]=${c.value}`,
							""
						),
						sorted[0]?.id,
						sorted[0]?.desc,
						toExport,
						callback
					)
				),
			500
		);

		getInvoicesDebounced();
	};

	return (
		<Report
			manual
			tableRef={table}
			title="Faturamento"
			onFetchData={handleFetchData}
			data={state.invoicing}
			pages={state.pages}
			loading={state.loading.invoicing}
			columns={[
				{
					Header: "Ano",
					id: "year",
					show: true,
					accessor: (c: any) => c.year,
					width: 100
				},
				{
					Header: ls.value,
					id: "total",
					show: true,
					filterable: false,
					accessor: (c: any) => toStringCurrency(+c.total / 100.0),
					width: 150
				}
			]}
			defaultSorted={[
				{
					id: "date",
					desc: true
				}
			]}
			filterable={false}
			getTdProps={() => {
				return {
					style: {
						display: "flex",
						alignItems: "center"
					}
				};
			}}
		/>
	);
}

export default Invoicing;
